import React, {Component} from 'react';
import Styles from './style.css';
import Slider, {Range} from 'rc-slider';
import Tooltip from 'rc-tooltip';
import 'rc-slider/assets/index.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";

const Handle = Slider.Handle;

class SignupBudgetBasic extends Component {

    constructor(props) {
        super(props);
        this.state = {
            channels: null,
            budget: null,
            currency: null,
            min: 0,
            max: 0,
            spend: 0,
            searchChunks: {},
            searchs: [7,6,5,4,3,2,1,0],
            clients: [],
            clientChunks: {},
            socialChunks: {},
            socials: [3,2,1,0],
            searchDisabled: true,
            responsive: false
        };
    };

    componentWillMount() {
        this.setState({
            channels: this.props.channels,
            budget: this.props.budget,
            currency: this.props.currency
        }, () => {
            this._updateSlider();
            this._updateAutoProperty();
            this._updateWindowSize();
        });
        window.addEventListener("resize", this._updateAnimations.bind(this));
    }

    componentWillReceiveProps(nextProps) {
        this.setState({budget: nextProps.budget}, () => {
            this._updateSpend();
        });
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this._updateAnimations.bind(this));
    }

    _updateWindowSize(){
        window.innerWidth;
        if(window.innerWidth > 1050){
            this.setState({responsive: true});
        }
    }

    _updateSpend(){
        let max = 0;
        let spend = 0;
        let min = 0;
        for(var key in this.state.channels){
            if(this.state.channels[key].selected){
                max = max + this.state.budget[key].budget;
                spend = spend + this.state.budget[key].spend;
                min = min + this.state.budget[key].min_budget;
            }
        }
        this.setState({min: min, max: max, spend: spend});
    }

    _updateAutoProperty(){
        //SET AUTO PROPERTY (OFF)
        for(var key in this.state.channels) {
            if (this.state.channels[key].selected) {
                this.state.budget[key].auto = true;
            }
        }
        this.props.updateBudget(this.state.budget);
    }

    _updateSlider(){
        //INIT MAX BUDGET
        let max = 0;
        let spend = 0;
        let min = 0;
        for(var key in this.state.channels){
            if(this.state.channels[key].selected){
                max = max + this.state.budget[key].budget;
                spend = spend + this.state.budget[key].spend;
                min = min + this.state.budget[key].min_budget;
                if(this.state.budget[key].min_budget < this.state.budget[key].budget && this.state.budget[key].search){
                    this.setState({searchDisabled: false});
                }
            }
        }
        this.setState({max: max, spend: spend, min: min}, () => {
           this._updateAnimations();
        });
    }

    _updateAnimations(){
        if(this.state.max && this.state.spend && this.state.min){
            let clientLenght = 545;
            if(window.innerWidth < 1050){
                clientLenght = 170;
            }
            //INIT SEARCH
            let searchAmount = 8;
            let searchChunks = {};
            let searchChunkSize = (this.state.max / 6) / searchAmount;
            for(let i = 0; i <= searchAmount; i++){
                searchChunks[i] = searchChunkSize * i;
            }
            //INIT SOCIAL
            let socialAmount = 4;
            let socialChunks = {};
            let socialChunkSize = (this.state.max / 4) / socialAmount;
            for(let i = 0; i <= socialAmount; i++){
                socialChunks[i] = socialChunkSize * i;
            }
            //INIT CLIENTS
            this.state.clients = Array.apply(null, {length: clientLenght}).map(function(value, index){
                return index + 1;
            });
            this.state.clients = this.state.clients.reverse();
            let clientAmount = clientLenght;
            let clientChunks = {};
            let clientChunkSize = this.state.max / clientAmount;
            for(let i = 0; i <= clientAmount; i++){
                clientChunks[i] = clientChunkSize * i;
            }
            this.setState({socialChunks: socialChunks, searchChunks: searchChunks, clientChunks: clientChunks, clients: this.state.clients}, () => {
                this._setSpend(this.state.spend);
            });
        }
    }

    _decreaseSpend(key) {
        let spend = this.state.spend - 1;
        if ((spend - this.state.min) <= 0) {
            this._setSpend(this.state.min);
        } else if (this.state.min <= spend) {
            this._setSpend(spend);
        }
    }

    _increaseSpend(key) {
        let spend = this.state.spend + 1;
        if (spend >= this.state.max) {
            this._setSpend(this.state.max);
        } else if (this.state.max >= spend) {
            this._setSpend(spend);
        }
    }

    _setSpend(value){
        try {
            let budget = value;
            for(var key in this.state.channels){
                if(this.state.channels[key].selected){
                    this.state.budget[key].spend = this.state.budget[key].min_budget;
                    budget = budget - this.state.budget[key].spend;
                }
            }
            while(budget > 1){
                for(var key in this.state.channels){
                    if(this.state.channels[key].selected){
                        let spend = this.state.budget[key].spend;
                        this.state.budget[key].spend = this.state.budget[key].spend + (budget * this.state.budget[key].allocation);
                        if(this.state.budget[key].spend > this.state.budget[key].budget){
                            this.state.budget[key].spend = this.state.budget[key].budget;
                            budget = budget - (this.state.budget[key].budget - spend);
                        }else{
                            budget = budget - (budget * this.state.budget[key].allocation);
                        }
                    }
                }
            }
            let allocation = 0;
            let channel = null;
            for(var key in this.state.channels){
                if(this.state.channels[key].selected){
                    if(this.state.budget[key].allocation > allocation && this.state.budget[key].spend < this.state.budget[key].budget){
                        channel = key;
                    }
                }
            }
            this.state.budget[channel].spend = this.state.budget[channel].spend + budget;
            this.setState({spend: value, budget: this.state.budget}, () => {
                this.props.updateBudget(this.state.budget);
            });
        }catch (e) {}
    }

    _renderHandle(props) {
        const {value, impressions, titleTwo, dragging, index, budget, currency, title, min, max, ...restProps} = props;
        return (
            <Tooltip
                prefixCls="rc-slider-tooltip"
                overlay={value}
                visible={true}
                placement="top"
                key={index}
                arrowContent={
                    <div className={
                        cx(Styles.sliderContainerHandle,
                            {
                                [Styles.sliderContainerHandleLow]: min === max
                            })
                    }>
                        <div className={
                            cx(Styles.sliderContainerHandleTitle,
                                {
                                    [Styles.sliderContainerHandleTitleLow]: min === max
                                })
                        }>
                            <div className={Styles.sliderContainerHandleTitleDesktop}>{title}</div>
                            <div className={Styles.sliderContainerHandleTitleMobile}>
                                <div className={Styles.sliderContainerHandleTitleMobileTitle}>
                                    {titleTwo}
                                </div>
                                <div className={Styles.sliderContainerHandleTitleMobileValue}>
                                    {impressions}
                                </div>
                            </div>
                        </div>
                        <div className={Styles.sliderContainerHandleValue}>
                            {value}<span className={Styles.sliderContainerHandleValueCurrency}>{currency}</span>
                        </div>
                        <div className={
                            cx(Styles.sliderContainerHandleArrow,
                                {
                                    [Styles.sliderContainerHandleArrowGrey]: min === max
                                })
                        }/>
                    </div>}
            >
                <Handle value={value} {...restProps} />
            </Tooltip>
        );
    }

    _renderSearchItem(index){
        if(this.state.searchDisabled){
            return(<img className={Styles.rankIndicatorItemImage} src={require("../../assets/images/basic-slider/AB_search_grey.png")}/>)
        }else{
            if(index !== 7){
                if(this.state.spend >= this.state.searchChunks[index] && this.state.spend < this.state.searchChunks[index + 1]){
                    return(<img className={Styles.rankIndicatorItemImage} src={require("../../assets/images/basic-slider/AB_search_highlight.png")}/>)
                }else{
                    return(<img className={Styles.rankIndicatorItemImage} src={require("../../assets/images/basic-slider/AB_search.png")}/>)
                }
            }else if(this.state.spend > this.state.searchChunks[index]){
                return(<img className={Styles.rankIndicatorItemImage} src={require("../../assets/images/basic-slider/AB_search_highlight.png")}/>)
            }else{
                return(<img className={Styles.rankIndicatorItemImage} src={require("../../assets/images/basic-slider/AB_search.png")}/>)
            }
        }
    }

    _renderSocialItem(index){
        if(this.state.spend > this.state.socialChunks[index] ){
            return(<img className={Styles.rankIndicatorItemImage} src={require("../../assets/images/basic-slider/AB_social_highlight.png")}/>)
        }else{
            return(<img className={Styles.rankIndicatorItemImage} src={require("../../assets/images/basic-slider/AB_social.png")}/>)
        }
    }

    _renderClientItem(index){
        if(!this.state.searchDisabled || Object.keys(this.state.channels).filter((item) => {
            return this.state.budget[item].social && this.state.channels[item].selected
        }).length > 0){
            if(this.state.spend < this.state.clientChunks[index]){
                return(<img className={Styles.clientsLayerItem} src={require("../../assets/images/AB_Client_Grey.png")}/>)
            }else{
                return(<img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>)
            }
        }
    }

    _renderImpressionsBySpend() {
        let impressions = 0;
        if (this.state.budget) {
            for (let key in this.state.channels) {
                if (this.state.channels[key].selected) {
                    impressions = impressions + (this.state.budget[key].spend / this.state.budget[key].cpi);
                }
            }
            return Math.ceil(impressions);
        } else {
            return (0);
        }
    }

    _renderLeadsBySpend() {
        let clicks = 0;
        if (this.state.budget) {
            for (let key in this.state.channels) {
                if (this.state.channels[key].selected) {
                    clicks = clicks + Math.ceil(this.state.budget[key].spend / this.state.budget[key].cpc);
                }
            }
            return clicks;
        } else {
            return (0);
        }
    }

    _renderText(item) {
        return langRegister.get("budget-basic", item, this.state.temp_lang);
    }

    render() {
        return (
            <div className={Styles.sliderContainer}>
                {
                    this.state.channels && this.state.budget && this.state.currency &&
                    <div className={Styles.rankIndicator}>
                        <div className={Styles.rankIndicatorInner}>
                            {
                                Object.keys(this.state.channels).filter((item) => {
                                    return this.state.budget[item].search && this.state.channels[item].selected
                                }).length > 0 &&
                                <div className={Styles.rankIndicatorItem}>
                                    <div className={
                                        cx(Styles.rankIndicatorItemTitle,
                                            {
                                                [Styles.rankIndicatorItemTitleLow]: this.state.searchDisabled
                                            })
                                    }>
                                        {this._renderText("item_5")}
                                    </div>
                                    {
                                        this.state.searchs.map((item, i) => {
                                            return(
                                                this._renderSearchItem(item)
                                            )
                                        })
                                    }
                                </div>
                            }
                            {
                                Object.keys(this.state.channels).filter((item) => {
                                    return this.state.budget[item].social && this.state.channels[item].selected
                                }).length > 0 &&
                                <div className={Styles.rankIndicatorItem}>
                                    <div className={Styles.rankIndicatorItemTitle}>
                                        {this._renderText("item_6")}
                                    </div>
                                    {
                                        this.state.socials.map((item, i) => {
                                            return(
                                                this._renderSocialItem(item)
                                            )
                                        })
                                    }
                                </div>
                            }
                        </div>
                        <div className={Styles.clientsLayer}>
                            {
                                this.state.clients.map((item) => {
                                    return(
                                        this._renderClientItem(item)
                                    )
                                })
                            }
                            {
                                (!this.state.searchDisabled || Object.keys(this.state.channels).filter((item) => {
                                    return this.state.budget[item].social && this.state.channels[item].selected
                                }).length > 0) &&
                                <span>
                                     <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                            <img className={Styles.clientsLayerItemActive} src={require("../../assets/images/AB_Client_Grey.png")}/>
                                </span>
                            }
                        </div>
                        <div className={Styles.gradient}/>
                    </div>
                }
                <div className={Styles.sliderContainerInner}>
                    <div className={
                        cx(Styles.sliderContainerMinusButton,
                            {
                                [Styles.sliderContainerButtonDeactivated]: this.state.min === this.state.max
                            })
                    } onClick={() => this._decreaseSpend()}>
                        <img className={Styles.durationContainerValueMinusIcon}
                             src={require("../../assets/images/minus_icon_white_small.png")}/>
                    </div>
                    <div className={
                        cx(Styles.sliderContainerHandleMobile,
                            {
                                [Styles.sliderContainerHandleLow]: this.state.min === this.state.max
                            })
                    }>
                        <div className={
                            cx(Styles.sliderContainerHandleTitle,
                                {
                                    [Styles.sliderContainerHandleTitleLow]: this.state.min === this.state.max
                                })
                        }>
                            test
                        </div>
                        <div className={Styles.sliderContainerHandleValue}>{this.state.spend}<span className={Styles.sliderContainerHandleValueCurrency}>{this.state.currency}</span></div>
                    </div>
                    <Slider
                        index={1}
                        min={this.state.min}
                        max={this.state.max}
                        value={this.state.spend}
                        onChange={(value) => this._setSpend(value)}
                        title={this._renderText("item_1")}
                        titleTwo={this._renderText("item_4")}
                        currency={this.state.currency}
                        impressions={this._renderLeadsBySpend()}
                        handle={this._renderHandle}
                    />
                    <div className={
                        cx(Styles.sliderContainerRail,
                            {
                                [Styles.sliderContainerRailDisabled]: this.state.min === this.state.max
                            })
                    }>
                        <div className={
                            cx(Styles.sliderContainerRailLeft,
                                {
                                    [Styles.sliderContainerRailLeftLow]: this.state.min === this.state.max
                                })
                        }/>
                        <div className={
                            cx(Styles.sliderContainerRailRight,
                                {
                                    [Styles.sliderContainerRailRightLow]: this.state.min === this.state.max
                                })
                        }/>
                        {
                            this.state.min === this.state.max &&
                            <div className={Styles.sliderContainerHandleSliderLow}/>
                        }
                        {
                            this.state.min === this.state.max &&
                            <div className={Styles.sliderContainerLowTrafficTitle}>
                                {this._renderText("item_2")}
                            </div>
                        }
                        {
                            this.state.min !== this.state.max &&
                            <div className={Styles.sliderContainerInfoTitle}>
                                {this._renderText("item_3")}
                            </div>
                        }
                    </div>
                    <div className={
                        cx(Styles.sliderContainerPlusButton,
                            {
                                [Styles.sliderContainerButtonDeactivated]: this.state.min === this.state.max
                            })
                    } onClick={() => this._increaseSpend()}>
                        <img className={Styles.durationContainerValuePlusIcon} src={require("../../assets/images/plus_sign_white_small.png")}/>
                    </div>
                </div>
            </div>
        );
    }
}

/*
<Slider
                        index={1}
                        min={this.state.min}
                        max={this.state.max}
                        value={this.state.spend}
                        onChange={(value) => this._setSpend(value)}
                        title={this._renderText("item_1")}
                        titleTwo={this._renderText("item_4")}
                        currency={this.state.currency}
                        impressions={this._renderImpressionsBySpend()}
                        handle={this._renderHandle}
                    />
 */

/*
<div className={
                    cx(Styles.sliderContainerMinusButton,
                        {
                            [Styles.sliderContainerButtonDeactivated]: this.state.min === this.state.max
                        })
                } onClick={() => this._decreaseSpend()}>
                    <img className={Styles.durationContainerValueMinusIcon}
                         src={require("../../assets/images/minus_icon_white_small.png")}/>
                </div>
                <div className={
                    cx(Styles.sliderContainerHandleMobile,
                        {
                            [Styles.sliderContainerHandleLow]: this.state.min === this.state.max
                        })
                }>
                    <div className={
                        cx(Styles.sliderContainerHandleTitle,
                            {
                                [Styles.sliderContainerHandleTitleLow]: this.state.min === this.state.max
                            })
                    }>
                        test
                    </div>
                    <div className={Styles.sliderContainerHandleValue}>{this.state.spend}<span className={Styles.sliderContainerHandleValueCurrency}>{this.state.currency}</span></div>
                </div>
                <Slider
                    index={1}
                    min={this.state.min}
                    max={this.state.max}
                    value={this.state.spend}
                    onChange={(value) => this._setSpend(value)}
                    title={this._renderText("item_1")}
                    titleTwo={this._renderText("item_4")}
                    currency={this.state.currency}
                    impressions={this._renderImpressionsBySpend()}
                    handle={this._renderHandle}
                />
                <div className={Styles.sliderContainerRail}>
                    <div className={
                        cx(Styles.sliderContainerRailLeft,
                            {
                                [Styles.sliderContainerRailLeftLow]: this.state.min === this.state.max
                            })
                    }/>
                    <div className={
                        cx(Styles.sliderContainerRailRight,
                            {
                                [Styles.sliderContainerRailRightLow]: this.state.min === this.state.max
                            })
                    }/>
                    {
                        this.state.min === this.state.max &&
                        <div className={Styles.sliderContainerHandleSliderLow}/>
                    }
                    {
                        this.state.min === this.state.max &&
                        <div className={Styles.sliderContainerLowTrafficTitle}>
                            {this._renderText("item_2")}
                        </div>
                    }
                    {
                        this.state.min !== this.state.max &&
                        <div className={Styles.sliderContainerInfoTitle}>
                            {this._renderText("item_3")}
                        </div>
                    }
                </div>
                <div className={
                    cx(Styles.sliderContainerPlusButton,
                        {
                            [Styles.sliderContainerButtonDeactivated]: this.state.min === this.state.max
                        })
                } onClick={() => this._increaseSpend()}>
                    <img className={Styles.durationContainerValuePlusIcon} src={require("../../assets/images/plus_sign_white_small.png")}/>
                </div>
 */

export default SignupBudgetBasic;


// WEBPACK FOOTER //
// ./src/components/signup-budget-basic/component.js